import { BsFillEnvelopeFill } from 'react-icons/bs';
import { MdArrowForwardIos } from 'react-icons/md';

export default function MailButton({
  message,
  mail,
  theme = 'yellow',
}: {
  message?: string;
  mail?: string;
  theme?: 'yellow' | 'green';
}) {
  if (!mail) {
    mail = process.env.NEXT_PUBLIC_MAIL;
  }
  if (!mail) {
    return null;
  }
  const href = message ? `mailto:${mail}${message}` : `mailto:${mail}`;

  const classes =
    theme === 'yellow'
      ? 'border-black bg-brand text-black'
      : theme === 'green'
        ? 'border-accent bg-accent text-white'
        : '';
  return (
    <a
      href={href}
      className={`flex items-center justify-between gap-2 border-2 p-2 px-4 pr-2 font-bold hover:bg-black hover:text-white focus:bg-black focus:text-white ${classes}`}
    >
      <span className='flex items-center gap-2 break-all'>
        <BsFillEnvelopeFill /> {mail.replaceAll('@', '​@')}
      </span>
      <span>
        <MdArrowForwardIos />
      </span>
    </a>
  );
}
